import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    datePicker: {
        '& fieldset': {
            borderRadius: 40,
            borderWidth: 2,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                //borderColor: theme.palette.primary.light,
            },
        },
        '& input': {
            color: theme.palette.secondary.main,
            fontWeight: 'bold',
            fontSize: 18,
            textAlign: 'center'
        }
    },
    toggleButtonGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
        "& .MuiToggleButton-root.Mui-selected + .MuiToggleButton-root.Mui-selected": {
            borderWidth: 2,
            marginLeft: 4,
        }
    },
    toggleButton: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.light,
        borderRadius: 40,
        borderWidth: 2,
        fontWeight: 'bold',
        margin: 4,
        flexGrow: 1
    },
    select: {
        '& fieldset': {
            borderRadius: 40,
            borderWidth: 2,
        },
    },
    provSelect: {
        '& .MuiInputBase-root': {
          '& fieldset': {
            borderRadius: 4,
            borderWidth: 2,
          },
          '&.Mui-disabled': {
           
            color:'#000000',
          },
        },
        '& .MuiInputLabel-root': {
          '&.Mui-disabled': {
            color: '#000000',
          },
        },
      },
}));

export default useStyles;